import { Capacitor } from '@capacitor/core';
import { APP_FLAVOR } from './flavor';

/** True when running inside a Capacitor native shell (iOS or Android). */
export const isNative = Capacitor.isNativePlatform();

/** 'ios' | 'android' | 'web' */
export const platform = Capacitor.getPlatform();

export const isIOS = platform === 'ios';
export const isAndroid = platform === 'android';

/** Custom URL scheme used for OAuth deep links back into the app. */
export const APP_URL_SCHEME = (() => {
  // Same resolution as APP_FLAVOR (incl. the native fallback to traveler),
  // so a mis-built native app still gets its OAuth redirect back.
  if (APP_FLAVOR === 'traveler') return 'com.sekretly.traveler';
  return 'com.sekretly.app';
})();

/** Where OAuth providers redirect after auth. */
export const OAUTH_REDIRECT_NATIVE = `${APP_URL_SCHEME}://auth/callback`;
export const OAUTH_REDIRECT_WEB = `${typeof window !== 'undefined' ? window.location.origin : ''}/auth/callback`;
